// Step 3 first fill request (CHA1-4909).
export const SUGGESTIONS_STATUS = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  DONE: "done",
  FAILED: "failed"
})

// `payment_identifiers.first_fill` from the Configure read: which Step 3 fields still wait
// for their first fill (null = none).
export const FIRST_FILL = Object.freeze({
  ALL: "all",
  ARN: "arn"
})
